import React, { Component } from 'react';
import CategoryTitlesSelector from './CategoryTitlesSelector/CategoryTitlesSelector';
import classes from './Title.module.css';
import ContentTypes from 'components/UI/ContentTypes/ContentTypes';

class Title extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedCategoryName: this.props.selectedCategory,
      // selectedCategoryImage: this.props.selectedCategoryImage,
      selectedCategoryPrompt: null,
    };
    this.textInput = React.createRef();
  }

  componentDidMount() {
    this.textInput.current.focus();
  }

  selectCategory = (categoryName) => {
    this.props.toggleRenderStatus('Ideas');
    this.setState({ selectedCategoryName: categoryName });
  };

  closeDrawer = () => {
    if (this.state.showCategoryTitlesSelector === false) {
      this.props.close();
    } else {
      this.props.toggleRenderStatus('Add Title');
    }
  };

  handleTitleIdeaSelection = (prompt, tags) => {
    this.props.handleCategoryPromptSelection(this.state.selectedCategoryName, tags);
    this.props.toggleRenderStatus('Add Title');
    this.setState({ selectedCategoryPrompt: prompt });
  };

  render = () => {
    const titleDrawerClasses = [classes.TitleDrawer];
    if (this.props.shortWindow === true) titleDrawerClasses.push(classes.ShortWindow);
    const titleSetterClasses = this.props.openedDrawer === 'Add Title' ? [classes.TitleSetter] : [classes.TitleSetter, classes.Hidden];
    const categoryTitlesClasses = this.props.openedDrawer === 'Ideas' ? [classes.categoryTitles, classes.Show] : [classes.categoryTitles];
    const titlePromptClasses = this.state.selectedCategoryPrompt ? [classes.TitlePrompt, classes.PromptSelected] : [classes.TitlePrompt];
    return (
      <div className={titleDrawerClasses.join(' ')}>
        <div className={titleSetterClasses.join(' ')}>
          <div className={classes.InputContainer}>
            <div className={classes.TextAreaWrapper}>
              <textarea
                {...this.props.elementConfig}
                name="title"
                value={this.props.value}
                onChange={this.props.changed}
                placeholder={this.props.placeholder}
                readOnly={this.props.readOnly}
                ref={this.textInput}
                className={classes.TitleInput}
              />
            </div>
            <p className={titlePromptClasses.join(' ')}>
              {this.state.selectedCategoryPrompt !== null ? this.state.selectedCategoryPrompt : 'or choose from these ideas'}
            </p>
          </div>
          <div className={classes.CategoriesList}>
            <ContentTypes clicked={this.selectCategory} classIdentifier="TitleCategorySelector" />
          </div>
        </div>
        <div className={categoryTitlesClasses.join(' ')}>
          <CategoryTitlesSelector
            shortWindow={this.props.shortWindow}
            contentCategory={this.state.selectedCategoryName}
            clicked={this.handleTitleIdeaSelection}
          />
        </div>
      </div>
    );
  };
}

export default Title;
